import React, { useState, useEffect } from "react";
import { UseApiCall } from "hooks";
import { Button, Modal, Spin } from "antd";
import { ReactComponent as CloseIconSvg } from "../../icons/Close.svg";
import {
  ENVIORNMENTS,
  getCurrentEnviornment,
  REACT_APP_BaseServerURL,
  REACT_APP_BaseServerURL_SANDBOX,
} from "utils/constants";

export const VideoModal = ({
  setVideoModalOpen,
  videoModalOpen,
  showUrl,
  fileid,
  setFileId,
}) => {
  const [loader, setLoader] = useState(false);
  const [videoLink, setVideoLink] = useState("");

  useEffect(() => {
    if (showUrl) {
      getVideoLink();
    }
  }, [showUrl]);

  const handleCancel = () => {
    setFileId("");
    setVideoLink("");
    setVideoModalOpen({
      ...videoModalOpen,
      playVideoModal: false,
    });
  };
  const combineURL = (url) => {
    const baseUrl =
      getCurrentEnviornment() === ENVIORNMENTS.LIVE
        ? REACT_APP_BaseServerURL
        : REACT_APP_BaseServerURL_SANDBOX;
    return baseUrl + url;
  };
  const raw = JSON.stringify({
    fileid: fileid + "_2d",
  });

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  async function getVideoLink() {
    try {
      const response = await fetch(
        combineURL("get_video_pose"),
        requestOptions
      );
      if (response.ok) {
        const data = await response.json(); // or .text() / .blob() depending on response type
        setVideoLink(data?.pre_signed_url);
      }
    } catch (error) {
      console.log({ error });
    }
  }

  return (
    <div>
      <Modal
        className={`logoutModal`}
        title=""
        open={videoModalOpen.playVideoModal}
        cancelText="No"
        centered={true}
        okText="Yes"
        width={900}
        footer={null}
        onCancel={handleCancel}
        closeIcon={<CloseIconSvg />}
      >
        <Spin spinning={loader}>
          <div className="Video-wrapper" style={{ width: "98%" }}>
            <video
              controls
              src={videoLink}
              style={{ height: "510px", width: "100%" }}
              preload={"auto"}
              onLoadStart={() => {
                console.log("I am loading");
              }}
              // onLoadedData={() => {
              //   console.log("loaded Video");
              //   setLoader(false);
              // }}
              onCanPlayThrough={() => {
                console.log("video loaded");
                setTimeout(() => {
                  setLoader(false);
                }, 1000);
              }}
            />
          </div>
        </Spin>
      </Modal>
    </div>
  );
};
